import { instance as axios } from '../untils/http'
import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { errorHandler } from '../untils/errorHandler';
import { ErrorInformation } from 'src/models/errorInformation';
import { OptionAcceptOffer , VestingMaster } from 'src/models/acceptofferDetail';

//================|| OPTION ACCEPT OFFER SLICE ||=================//
type OptionAcceptOfferDetailState = {
    loading: boolean;
    error: ErrorInformation;
    optionAcceptOffers: OptionAcceptOffer[];
    vestingMaster: VestingMaster;
}

type GrantNoAndID = {
    grantNo: string,
    userID: string
}

const initialState: OptionAcceptOfferDetailState = {
    loading: true,
    error: null,
    optionAcceptOffers: [],
    vestingMaster: null
};

export const getAcceptOfferDetail = createAsyncThunk<OptionAcceptOffer[], {}, { rejectValue: ErrorInformation }>(
    "acceptOfferDetail/getAcceptOfferDetail",
    async ({ }, { rejectWithValue }) => {
        try {
            const optionAcceptOfferResponse = await axios.get<OptionAcceptOffer[]>('MyOption/GetAcceptOffer');
            return optionAcceptOfferResponse.data
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
);

export const getVestingSchedule = createAsyncThunk(
    "performanceViewAwardDetail/getVestingSchedule",
    async (grantNoAndID: GrantNoAndID, { rejectWithValue }) => {
        try {
            const getVestingScheduleResponse = await axios.get<VestingMaster>(`Misc/getOptionVestingSchedule?GrantNo=${grantNoAndID.grantNo}&GrantUserID=${grantNoAndID.userID}`)
            return getVestingScheduleResponse.data
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

export const postAcceptOffer = createAsyncThunk(
    "acceptOfferDetail/postAcceptOffer",
    async (paramaters: { 
        grantNo: string,
        offerstatus: string,
    }, { rejectWithValue }) => {
        try {
            const optionPostAcceptOfferResponse = await axios.post('MyOption/SetAcceptOffer',{
                grantNo: paramaters.grantNo,
                acceptanceStatus: paramaters.offerstatus
            });
            return optionPostAcceptOfferResponse.data
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
);


const optionAcceptOfferDetailSlice = createSlice({
    name: 'acceptOfferDetail',
    initialState,
    reducers: {},
    extraReducers: {
        //get Accept Offer
        [getAcceptOfferDetail.pending.type]: (state) => {
            state.loading = true;
        },
        [getAcceptOfferDetail.fulfilled.type]: (state, action) => {
            state.optionAcceptOffers = action.payload;
            state.loading = false;
        },
        [getAcceptOfferDetail.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload
        },
        //get Vesting Schedule
        [getVestingSchedule.pending.type]: (state) => {
            state.loading = true;
        },
        [getVestingSchedule.fulfilled.type]: (state, action) => {
            state.vestingMaster = action.payload;
            state.loading = false;
        },
        [getVestingSchedule.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload
        },
        // update Accept Offer
        [postAcceptOffer.pending.type]: (state) => {
            state.loading = true;
        },
        [postAcceptOffer.fulfilled.type]: (state, action) => {
            state.loading = false;
            state.error = null;
        },
        [postAcceptOffer.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload;
        },
    }
})
export default optionAcceptOfferDetailSlice